import dayjs from 'dayjs';
import {
  TRADING_PROGRESS_STATUS_VARIABLES,
  TRANSPORTATION_VARIABLES,
  TYPE_OF_SERVICE_FCL_LCL_VARIABLES,
  HAZARDOUS_FLAG_VARIABLES,
} from 'lib-tw-common';

const defaultDate = dayjs()
  .subtract(1, 'month')
  .toDate();

// eslint-disable-next-line import/prefer-default-export
export const tradingFlowListFilterSchema = [
  {
    key: 'tradingProgressStatus',
    labelKey: 'Label.Trading Flow Status',
    type: 'select',
    showInChip: true,
    options: TRADING_PROGRESS_STATUS_VARIABLES.map(s => ({
      label: s.label,
      value: s.code,
    })),
    rules: [],
    props: { placeholder: 'Select', clearable: true },
  },
  {
    key: 'flowName',
    labelKey: 'Label.Flow Name',
    label: 'Flow Name',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'invoiceNo',
    labelKey: 'Label.Invoice No',
    label: 'Invoice No',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'flowCreateDatetime',
    labelKey: 'Label.Create Datetime',
    label: 'Create Datetime',
    type: 'daterange',
    props: {
      type: 'datetimerange',
      rangeSeparator: 'to',
      format: 'yyyy-MM-dd HH:mm',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      defaultTime: ['00:00:00', '23:59:59'],
      startPlaceholder: 'Start datetime',
      endPlaceholder: 'End datetime',
    },
  },
  {
    // SelectableTradingList側のflowUpdateDatetimeと同名にすると、TwTableFilterBar側の
    // グルーピングやチップの挙動（削除不可等）まで共有されてしまうため、TradingFlowList専用のキー名にしている。
    // ただし180日以内の選択制限付きピッカーはTwTableFilterBar側でキー名'lastUpdateDatetime'にも適用される。
    key: 'lastUpdateDatetime',
    labelKey: 'Label.Update Datetime',
    label: 'Update Datetime',
    type: 'daterange',
    props: {
      type: 'datetimerange',
      rangeSeparator: 'to',
      format: 'yyyy-MM-dd HH:mm',
      clearable: false,
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      defaultTime: ['00:00:00', '23:59:59'],
      startPlaceholder: 'Start datetime',
      endPlaceholder: 'End datetime',
      popperClass: 'within-system-trading-list-days',
    },
  },
  {
    // レイアウト専用のダミー項目。type: 'break'によりTwTableFilterBar側で
    // この位置に行の折り返し（改行）が入り、セクション(From)/(To)が次の行に表示される。
    key: 'sectionRowBreak',
    labelKey: '',
    type: 'break',
  },
  {
    key: 'fromSectionIds',
    labelKey: 'Label.Section(From)',
    label: 'From',
    type: 'select',
    multiple: true,
    options: [],
    props: {
      bindProp: 'sections',
      sourceKey: 'fromSections',
      popperClass: 'filter-select-dropdown',
    },
  },
  {
    key: 'toSectionIds',
    labelKey: 'Label.Section(To)',
    label: 'To',
    type: 'select',
    multiple: true,
    options: [],
    props: {
      bindProp: 'sections',
      sourceKey: 'toSections',
      popperClass: 'filter-select-dropdown',
    },
  },
  {
    key: 'tradingFlowId',
    labelKey: 'Label.Trading/Flow ID',
    label: 'Trading/Flow ID',
    type: 'text',
    props: {
      placeholder: 'Enter keyword',
      class: 'trading-flow',
      trim: true,
    },
  },
  {
    key: 'poNo',
    labelKey: 'Label.P/O No',
    label: 'P/O No.',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'contractDate',
    labelKey: 'Label.Contract Date',
    label: 'Contract Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      rangeSeparator: 'to',
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
    },
  },
  {
    key: 'sellerName',
    labelKey: 'Label.Seller',
    label: 'Seller',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'buyerName',
    labelKey: 'Label.Buyer',
    label: 'Buyer',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'goodsName',
    labelKey: 'Label.Main Goods',
    label: 'Main Goods',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'flowReference',
    labelKey: 'Label.Flow Reference',
    label: 'Flow Reference',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'flowUserName',
    labelKey: 'Label.Flow PIC',
    label: 'Flow PIC',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  // {
  //   key: 'ownerSectionIds',
  //   labelKey: 'Label.Owner',
  //   label: 'Owner',
  //   type: 'select',
  //   multiple: true,
  //   collapseTags: true,
  //   options: [],
  //   props: {
  //     class: 'section',
  //     popperClass: 'owner-section',
  //     placeholder: 'Select',
  //     clearable: true,
  //   },
  // },
  {
    key: 'forcedCloseIncludeHiddenFlow',
    labelKey: 'Label.Hidden Flow',
    type: 'checkbox',
    checkboxLabel: 'Label.Include Hidden Flow',
    rules: [],
    props: { clearable: true },
  },
  {
    key: 'vesselName',
    labelKey: 'Label.Vessel Name',
    label: 'Vessel Name',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'blNo',
    labelKey: 'Label.B/L No',
    label: 'B/L No',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'bookingNo',
    labelKey: 'Label.Booking No',
    label: 'Booking No',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'etdBlDate',
    labelKey: 'Label.ETD/BL Date',
    label: 'ETD/BL Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'loadingPortCurrentEtd',
    labelKey: 'Label.Current ETD',
    label: 'Current ETD',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'loadingPortAtd',
    labelKey: 'Label.ATD',
    label: 'ATD',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'currentEta',
    labelKey: 'Label.Discharging Current ETA',
    label: 'Discharging Current ETA',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'dischargingAta',
    labelKey: 'Label.ATA',
    label: 'ATA',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'portOfLoading',
    labelKey: 'Label.Port of Loading',
    label: 'Port of Loading',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'portOfDischarging',
    labelKey: 'Label.Port of Discharging',
    label: 'Port of Discharging',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'exRequestDeclarationDate',
    labelKey: 'Label.Ex Request Declaration Date',
    label: 'Ex Request Declaration Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'vanningDate',
    labelKey: 'Label.Vanning Date',
    label: 'Vanning Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'vanningPlace',
    labelKey: 'Label.Place of Vanning',
    label: 'Place of Vanning',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'cyCutDate',
    labelKey: 'Label.CY CUT',
    label: 'CY CUT',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'imRequestDeclarationDate',
    labelKey: 'Label.Im Request Declaration Date',
    label: 'Im Request Declaration Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'scheduledDeliveryDate',
    labelKey: 'Label.Scheduled Delivery Date',
    label: 'Scheduled Delivery Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'deliveryDate',
    labelKey: 'Label.Delivery Date',
    label: 'Delivery Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'scheduledDevanningDate',
    labelKey: 'Label.Scheduled Devanning Date',
    label: 'Scheduled Devanning Date',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'devanningPlace',
    labelKey: 'Label.Place of Devanning',
    label: 'Place of Devanning',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'warehouse',
    labelKey: 'Label.Warehouse',
    label: 'Warehouse',
    type: 'text',
    props: { placeholder: 'Enter keyword' },
  },
  {
    key: 'freeTime',
    labelKey: 'Label.Free Time',
    label: 'Free Time',
    type: 'daterange',
    props: {
      format: 'yyyy-MM-dd',
      defaultValue: defaultDate,
      startPlaceholder: 'Start date',
      endPlaceholder: 'End date',
      editable: false,
    },
  },
  {
    key: 'modeOfTransportation',
    labelKey: 'Label.Transportation',
    type: 'select',
    showInChip: true,
    options: TRANSPORTATION_VARIABLES.map(s => ({
      label: s.label,
      value: s.code,
    })),
    rules: [],
    props: { placeholder: 'Select', clearable: true },
  },
  {
    key: 'typeOfServiceFrom',
    labelKey: 'Label.Type Of Service From',
    type: 'select',
    showInChip: true,
    options: TYPE_OF_SERVICE_FCL_LCL_VARIABLES.map(s => ({
      label: s.label,
      value: s.code,
    })),
    rules: [],
    props: { placeholder: 'Select', clearable: true },
  },
  {
    key: 'hazardousFlag',
    labelKey: 'Label.Hazardous',
    type: 'select',
    showInChip: true,
    options: HAZARDOUS_FLAG_VARIABLES.map(s => ({
      label: s.label,
      value: s.code,
    })),
    rules: [],
    props: { placeholder: 'Select', clearable: true },
  },
];
